import { useParams } from "../../../../router-utils"
import { Outlet } from "react-router"
import {
	Box,
	Spinner,
	Tabs,
	TabsList,
	TabContent,
	Alert,
} from "@sembark-travel/ui-base"
import { Breadcrumbs, NavLink } from "@sembark-travel/ui-router"
import { useXHR, XHRInstance } from "@sembark-travel/xhr"
import useSWR from "swr"
import { generatePath } from "../../../../router-utils"
import { TTouristProfile } from "../../../../TouristProfiles"

function XHR(xhr: XHRInstance) {
	return {
		async get(id: string | number, params: unknown) {
			return xhr
				.get<{ data: TTouristProfile }>(`/tourist-profiles/${id}`, { params })
				.then((resp) => resp.data.data)
		},
	}
}

export default function TouristProfileDetailsLayout() {
	const { touristProfileId } = useParams("/tourist-profiles/:touristProfileId")
	const xhr = useXHR()

	const {
		data: touristProfile,
		error,
		mutate: fetchTouristProfile,
		isLoading,
		isValidating,
	} = useSWR(
		touristProfileId ? `/api/tourist-profiles/${touristProfileId}` : null,
		() => XHR(xhr).get(touristProfileId, {})
	)

	if (isLoading || isValidating) {
		return <Spinner alignCenter padding="4" />
	}

	if (!touristProfile) {
		if (error) {
			return <Alert status="error">{error.message}</Alert>
		}
		return <Box>Tourist Profile does not exist</Box>
	}

	const { name } = touristProfile

	return (
		<Box>
			<Breadcrumbs
				title={name}
				items={[[generatePath("/org/tourists/profiles"), "Tourist Profiles"]]}
			/>
			<Box>
				<Tabs layout="col" gap="0">
					<TabsList>
						<NavLink
							to={generatePath("/tourist-profiles/:touristProfileId", {
								touristProfileId,
							})}
							end
						>
							Details
						</NavLink>
						<NavLink
							to={generatePath(
								"/tourist-profiles/:touristProfileId/documents",
								{
									touristProfileId,
								}
							)}
							end
						>
							Documents
						</NavLink>
						<NavLink
							to={`${generatePath("/tourist-profiles/:touristProfileId/trips", {
								touristProfileId,
							})}?status=all&page=1`}
						>
							Trips
						</NavLink>
					</TabsList>
					<TabContent>
						<Outlet
							context={{
								touristProfile,
								revalidate: fetchTouristProfile,
							}}
						/>
					</TabContent>
				</Tabs>
			</Box>
		</Box>
	)
}
